module.exports = __webpack_public_path__ + "img/banner09.10099e9d.png";